import css from '../../../utils/css';

export default css`
:host {
  --widget-font-family: Roboto, sans-serif;

	--gazzetta-black: #000;
	--gazzetta-orange: #e27e3a;
	--gazzetta-pink: #ebccce;
	--gazzetta-white: #FFF;


  --widget-background-color: var(--gazzetta-pink);
  --widget-text-color: var(--gazzetta-black);
  --widget-subtext-color: var(--gazzetta-black));
  --widget-border-color: var(--gazzetta-pink);
  --widget-divider-color: rgba(0,0,0,0.3);

  --widget-header-bg-color: var(--gazzetta-black);
  --widget-header-text-color: var(--gazzetta-orange);
  --widget-header-odds-bg-color: #eaeae9;
  --widget-header-odds-shadow: #bbb;

  --widget-mobile-seeall-color: var(--gazzetta-orange);

  --widget-grid-best-odds-bg-color: var(--gazzetta-orange);
  --widget-grid-best-odds-border-color: var(--gazzetta-orange);
  --widget-grid-best-odds-text-color: var(--gazzetta-white);

  --widget-grid-compare-active-bg-color: var(--gazzetta-orange);
  --widget-grid-compare-color: var(--gazzetta-black);

  --widget-grid-ribbon-bg-color: transparent;
  --widget-grid-ribbon-color: var(--gazzetta-white);
}
`;
